import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getPaymentMethods } from '../../../redux/pharmacies';

import PaymentMethodSettings from './PaymentMethodsSettings';

const PaymentMethodsContainer = ({ pharmacy, organisation, onChange }) => {
  const { paymentMethods } = useSelector(state => state.pharmacies);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPaymentMethods());
  }, [dispatch]);

  return (
    <PaymentMethodSettings
      paymentMethods={paymentMethods}
      pharmacy={pharmacy}
      organisation={organisation}
      onChange={onChange}
    />
  );
};

export default PaymentMethodsContainer;
